module.exports = __webpack_public_path__ + "static/media/story.12820de0.svg";